exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.brand[data-v-1150b092]{padding:10px\n}\n.brand .el-button[data-v-1150b092]{width:100px;height:35px;margin:70px 220px;line-height:10px\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/pages/basic/brand.vue"],"names":[],"mappings":";AA+FA,wBACE,YAAa;CADf;AAAA,mCAGI,YACA,YACA,kBACA,gBAAiB;CAClB","file":"brand.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.brand {\n  padding: 10px;\n  .el-button {\n    width: 100px;\n    height: 35px;\n    margin: 70px 220px;\n    line-height: 10px;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1150b092","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/basic/brand.vue
// module id = MWX2
// module chunks = 2